import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../Event/event';

const shapes = [
  { name: 'Circle', type: 'circle' },
  { name: 'Square', type: 'square' },
  { name: 'Triangle', type: 'triangle' },
  { name: 'Rectangle', type: 'rectangle' },
  { name: 'Oval', type: 'oval' },
  { name: 'Star', type: 'star' },
  { name: 'Pentagon', type: 'pentagon' },
  { name: 'Hexagon', type: 'hexagon' },
  { name: 'Octagon', type: 'octagon' },
  { name: 'Semicircle', type: 'semicircle' },
  { name: 'Hexagram', type: 'hexagram' },
  { name: 'Rhombus', type: 'rhombus' },
  { name: 'Hendecagon', type: 'hendecagon' },
  { name: 'Prism', type: 'prism' },
  { name: 'Icosagon', type: 'icosagon' },
  { name: 'Nonagon', type: 'nonagon' },
  { name: 'Crescent', type: 'crescent' },
];

const shapeStyles = {
  base: {
    width: 140,
    height: 140,
    margin: '20px auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'transform 0.6s ease, box-shadow 0.3s ease',
    boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
    transform: 'scale(1)',
  },
  circle: { borderRadius: '50%', backgroundColor: '#f44336' },
  square: { backgroundColor: '#4caf50' },
  triangle: {
    width: 0,
    height: 0,
    borderLeft: '70px solid transparent',
    borderRight: '70px solid transparent',
    borderBottom: '140px solid #2196f3',
  },
  rectangle: { width: 160, height: 100, backgroundColor: '#ff9800' },
  oval: { width: 160, height: 100, borderRadius: '50%', backgroundColor: '#9c27b0' },
  pentagon: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://cdn-icons-png.flaticon.com/512/17950/17950169.png)',
    backgroundSize: 'cover',
  },
  hexagon: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://images.vexels.com/content/139197/preview/hexagon-shape-da2a48.png)',
    backgroundSize: 'cover',
  },
  octagon: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://images.vexels.com/media/users/3/139240/isolated/svg/14180b59b9e230b261ccb6a0bc64e5dc.svg)',
    backgroundSize: 'cover',
  },
  star: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://upload.wikimedia.org/wikipedia/commons/4/44/Plain_Yellow_Star.png)',
    backgroundSize: 'cover',
  },
  rhombus: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://cdn.abcteach.com/abcteach-content-free/docs/free_preview/r/rhombuscolor_p.png)',
    backgroundSize: 'cover',
  },
  crescent: {
    width: 120,
    height: 120,
    backgroundImage:
      'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0OWtZUmYpWtw5vF_Qmw50fe-JlhpAFdAQOQ&s)',
    backgroundSize: 'cover',
  },
  nonagon: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://images.vexels.com/content/139235/preview/nonagon-shape-silhouette-b1df49.png)',
    backgroundSize: 'cover',
  },
  icosagon: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://static.thenounproject.com/png/icosagon-icon-1484188-512.png)',
    backgroundSize: 'cover',
  },
  prism: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://cdn-icons-png.flaticon.com/512/9913/9913424.png)',
    backgroundSize: 'cover',
  },
  hendecagon: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://graphicmaths.com/img/gcse/geometry/11-sided-regular-polygon.png)',
    backgroundSize: 'cover',
  },
  hexagram: {
    width: 120,
    height: 120,
    backgroundImage: 'url(https://thumbs.dreamstime.com/b/abstract-hexagram-star-david-symbol-icon-abstract-hexagram-icon-362387619.jpg)',
    backgroundSize: 'cover',
  },
  semicircle: {
    width: 120,
    height: 120,
    backgroundImage:
      'url(https://images.vexels.com/media/users/3/139334/isolated/svg/c284ad929e46316c68bf34ffd55f9930.svg)',
    backgroundSize: 'cover',
  },
};

const getRandomOptions = (correctShape) => {
  const others = shapes.filter((s) => s.name !== correctShape.name);
  const random = others.sort(() => 0.5 - Math.random()).slice(0, 3);
  return [...random, correctShape].sort(() => 0.5 - Math.random());
};

const GuessTheShapeGame = () => {
  const [currentShape, setCurrentShape] = useState(null);
  const [options, setOptions] = useState([]);
  const [feedback, setFeedback] = useState('');
  const [animate, setAnimate] = useState(false);

  const generateQuestion = () => {
    const randomShape = shapes[Math.floor(Math.random() * shapes.length)];
    setCurrentShape(randomShape);
    setOptions(getRandomOptions(randomShape));
    setFeedback('');
    setAnimate(true);
    setTimeout(() => setAnimate(false), 800);
  };

  const checkAnswer = (answer) => {
    if (answer === currentShape.name) {
      setFeedback('✅ Correct!');
      ConstructorEventUpdateSQLStatus();
    } else {
      setFeedback(`❌ Oops! It was a ${currentShape.name}`);
    }
    setTimeout(generateQuestion, 1500);
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
        background: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
        fontFamily: "'Comic Sans MS', cursive",
        textAlign: 'center',
      }}
    >
      <h1 style={{ color: '#01579b', marginBottom: 30, fontSize: '2.5rem' }}>
        🔷 Guess the Shape!
      </h1>

      <div
        style={{
          ...shapeStyles.base,
          ...shapeStyles[currentShape?.type],
          transform: animate ? 'scale(1.1)' : 'scale(1)',
        }}
      ></div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 20,
          flexWrap: 'wrap',
          marginTop: 30,
        }}
      >
        {options.map((option) => (
          <button
            key={option.name}
            onClick={() => checkAnswer(option.name)}
            style={{
              padding: '12px 28px',
              fontSize: '1.2rem',
              borderRadius: '10px',
              border: 'none',
              background: '#0288d1',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => (e.target.style.background = '#0277bd')}
            onMouseLeave={(e) => (e.target.style.background = '#0288d1')}
          >
            {option.name}
          </button>
        ))}
      </div>

      <div
        style={{
          fontSize: '1.5rem',
          marginTop: '25px',
          color: feedback.startsWith('✅') ? '#2e7d32' : '#c62828',
          transition: 'opacity 0.3s ease',
          fontWeight: 'bold',
        }}
      >
        {feedback}
      </div>
    </div>
  );
};

export default GuessTheShapeGame;
